export default {
    install(Vue, options) {
      (function(w, d) {
        w.adthrive = w.adthrive || {};
        w.adthrive.cmd = w.adthrive.cmd || [];
        w.adthrive.plugin = 'adthrive-ads-manual-spa';
        w.adthrive.host = 'ads.adthrive.com';
        var s = d.createElement('script');
        s.async = true;
        s.referrerpolicy='no-referrer-when-downgrade';
        s.src = 'https://' + w.adthrive.host + `/sites/64d3f198093b3a088c314351/ads.min.js?referrer=` + w.encodeURIComponent(w.location.href);
        var n = d.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(s, n);
      })(window, document);
    }
}